export default "__VITE_PUBLIC_ASSET__a4a15e12__"